




























































































































import { IAlertState } from "@/@types/speciaMessage/speciaMessage";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import MainDemo from "@/components/demo/main-demo.vue";
import AlertMailDemo from "@/components/demo/mails/alert-mail-demo.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

interface IGroupedList {
  id: string;
  label: string;
  items: IAlertState[];
}

const DRAFT_TYPE = "__draft";
const TYPE_ORDER: string[] = ["hello", "birthday", DRAFT_TYPE];

@Component({
  components: { btn: ChangeDeliteButtons, MainDemo, AlertMailDemo, BSwitch },
})
class MessageAlertList extends Vue {
  @Prop({ type: Array, default: () => [] }) list!: Array<IAlertState>;
  @Prop({ type: Object, default: null }) mail!: IAlertState;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;

  folder = "global/mail/backgrounds";
  iconFolder = "global/mail/icons";

  weather = false;
  travel_time = false;
  show_arrival = false;
  saving = false;

  get grouped(): IGroupedList[] {
    const map = new Map<string, IAlertState[]>();
    for (const item of this.list) {
      const key = this.normalizeType(item.type);
      let bucket = map.get(key);
      if (!bucket) {
        bucket = [];
        map.set(key, bucket);
      }
      bucket.push(item);
    }
    const entries = Array.from(map.entries()).sort(([a], [b]) => {
      const ai = TYPE_ORDER.indexOf(a);
      const bi = TYPE_ORDER.indexOf(b);
      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return a.localeCompare(b);
    });
    return entries.map(([id, items]) => ({
      id,
      label: this.getGroupLabel(id),
      items,
    }));
  }

  normalizeType(type: string | null | undefined): string {
    if (!type || !String(type).trim()) return DRAFT_TYPE;
    return String(type);
  }

  getGroupLabel(id: string): string {
    if (id === DRAFT_TYPE) {
      return String(this.$t("Settings.hello.category.draft"));
    }
    const key = `Settings.hello.category.${id}`;
    const translated = this.$t(key);
    if (typeof translated === "string" && translated !== key) {
      return translated;
    }
    return id;
  }

  canToggleCurrent(item: IAlertState | null): boolean {
    if (!item) return false;
    const type = this.normalizeType(item.type);
    return type === "hello" || type === "birthday";
  }

  getItemTitle(item: IAlertState): string {
    if (item.title) return item.title;
    const localized = this.$getLocale(item.value);
    if (localized) return localized;
    return item._id;
  }

  change(type: string, event: boolean): void {
    if (!this.mail) return;
    let flags = this.mail.flags;
    if (!flags) {
      flags = {
        show_weather: false,
        show_route: false,
        show_arrival: false,
      };
    }
    if (type === "show_weather") flags.show_weather = event;
    if (type === "show_route") flags.show_route = event;
    if (type === "show_arrival") flags.show_arrival = event;
    this.$emit("sawe", this.mail._id, { flags });
  }

  async onToggleCurrent(item: IAlertState, value: boolean): Promise<void> {
    if (!item || this.saving) return;
    this.saving = true;
    try {
      if (value) {
        const itemType = this.normalizeType(item.type);
        for (const other of this.list) {
          if (
            other._id !== item._id &&
            this.normalizeType(other.type) === itemType &&
            other.current
          ) {
            this.$set(other, "current", false);
            this.$emit("sawe", other._id, { current: false });
          }
        }
      }
      this.$set(item, "current", value);
      this.$emit("sawe", item._id, { current: value });
    } finally {
      this.$nextTick(() => {
        this.saving = false;
      });
    }
  }

  async alertDeleted(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("mails.buttons.deleted")),
        }
      );

      if (result === true) {
        this.$emit("deleted", id);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  @Watch("mail")
  start(): void {
    if (!this.mail) return;
    this.weather = this.mail.flags ? this.mail.flags.show_weather : false;
    this.travel_time = this.mail.flags ? this.mail.flags.show_route : false;
    this.show_arrival = this.mail.flags ? this.mail.flags.show_arrival : false;
  }

  mounted(): void {
    this.$nextTick(() => this.start());
  }
}
export default MessageAlertList;
